<script setup>
  import { useI18n } from 'vue-i18n';
  import Popup from '@/components/controls/Popup.vue';
  import Icon from '@/components/icons/Icon.vue';

  const { t } = useI18n();
</script>

<template>
  <Popup
    id="spot-header-jwx-action-menu"
    positionY="bottom"
    class="jwx-toolbar-header__actions"
  >
    <template #button-content>
      <div class="jwx-popup__button">
        <Icon name="more-menu" class="jwx-user-favorite__menu-icon" />
        <span class='sr-only'>{{ t('completeReport.header.openActionMenu') }}</span>
      </div>
    </template>
    
    <template #menu-content>
      <div class="jwx-popup-menu">
        <slot name="menu-content"></slot>
      </div>
    </template>
    <template #misc></template>
  </Popup>      
</template>